import brandLogo from "../Online-Quran-Universe-Logo.jpg (1).png";

export default function BrandLogo({
  wrapperClassName = "",
  imageClassName = "",
  alt = "Online Quran Universe Academy logo",
}) {
  return (
    <div className={`overflow-hidden ${wrapperClassName}`}>
      <img
        src={brandLogo}
        alt={alt}
        className={`block w-full h-full object-contain mix-blend-darken scale-[1.85] origin-center ${imageClassName}`}
      />
    </div>
  );
}
